import { escapeRegExp } from "lodash";

const underline = (value: string, search: string | undefined) => {
  if (search && value) {
    const escaped = escapeRegExp(search);
    const reg = new RegExp(`(${escaped})`, 'i');
    return value?.replace(reg, '<em>$1</em>');
  } else {
    return value;
  }
};

export default underline;
